export default "__VITE_ASSET__c88f5b8c__"